import React, { createContext, useState, useEffect } from "react";
import { API_URL } from "../utils/config";
const baseUrl = API_URL;

const AuthContext = createContext({
  userName: "",
  setUserName: () => {},
  isAuthenticated: false,
  userRole: "",
  setUserRole: () => {},
  isLoading: true,
  logout: () => {},
  setIsAuthenticated: () => {}
});

export const AuthProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [userName, setUserName] = useState(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    return user ? `${user.firstName} ${user.familyName}` : "";
  });

  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("user")
  );
  const [userRole, setUserRole] = useState(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    return user ? user.organizer_access : "venue_owner";
  });

  useEffect(() => {
    // Initial authentication check
    const user = JSON.parse(localStorage.getItem("user"));

    if (user) {
      setUserName(`${user.firstName} ${user.familyName}`);
      setIsAuthenticated(true);
      setUserRole(user.organizer_access);
    } else {
      setUserName("");
      setIsAuthenticated(false);
    }

    setIsLoading(false);
  }, [localStorage.getItem("user")]);

  useEffect(() => {
    // Sync user data when userName changes
    const user = JSON.parse(localStorage.getItem("user"));
    if (userName && user) {
      localStorage.setItem("user", JSON.stringify(user));
    }
  }, [userName]);

 const userLogout = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/v1/attnd/auth/logout`, {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json",
          lang: localStorage.getItem("language") || "en",
        },
      });

      if (!response.ok) {
        console.error("Failed to logout");
        return;
      }
    } catch (error) {
      console.error("Error during logout:", error);
    }
}

const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("loginDate");
    localStorage.removeItem("activeVenue");
    setUserName("");
    setUserRole("");
    setIsAuthenticated(false);
    userLogout();
  };

  return (
    <AuthContext.Provider
      value={{
        userName,
        setUserName,
        isAuthenticated,
        setIsAuthenticated,
        isLoading,
        userRole,
        setUserRole,
        logout
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;